// App.jsx
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import SukoonVistaCover from '../images/projects/sukoon_vista_cover.png';

 const structuredData = {
    "@context": "https://schema.org",
    "@type": "RealEstateListing",
    "name": "Tower 4",
    "description": "Premium commercial office spaces available for sale at Tower 4, located on Capital Square B-17, Islamabad. Flexible 4-quarter installment plan available.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Capital Square, B-17",
      "addressLocality": "Islamabad",
      "addressRegion": "ICT",
      "addressCountry": "PK"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "PKR",
      "price": "522240000",
      "availability": "https://schema.org/InStock"
    }
  };

const SukoonVista = () => {
  const [activeUnit, setActiveUnit] = useState('type-a');
  const WHATSAPP = '923487172565';

  const UNITS = [
    {
      id: 'type-a',
      bedrooms: 2,
      area: '926 Sq.Ft',
      title: 'Two Bedrooms with Attached Washroom',
      features: [
        'Spacious TV Lounge and Dining Area',
        'American Style Kitchen',
        'Reserved Basement Parking',
        'Dam and Mountains View through Wide Garden'
      ],
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80'
    },
    {
      id: 'type-b',
      bedrooms: 2,
      area: '931 Sq.Ft',
      title: 'Two Luxury Bedrooms with Attached Washrooms',
      features: [
        'Spacious Lounge and Dining Area',
        'American Style Kitchen',
        'Reserved Basement Parking',
        'Fountain View through Wide Garden'
      ],
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80'
    },
    {
      id: 'type-c',
      bedrooms: 2,
      area: '1024 Sq.Ft',
      title: 'Two Luxury Bedrooms with Attached Washroom',
      features: [
        'American Style Kitchen',
        'Spaciously Built Garden Area',
        'Separate Balconies from Every Room',
        'Dam and Mountains View',
        'Reserved Basement Parking'
      ],
      image: 'https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&q=80'
    },
    {
      id: 'type-d',
      bedrooms: 3,
      area: '1350 Sq.Ft',
      title: 'Three Luxury Bedrooms with Attached Washroom',
      features: [
        'American Style Kitchen',
        'Spacious Garden Area and Three Balconies',
        'Reserved Basement Parking',
        'Dam and Mountains View'
      ],
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80'
    },
    {
      id: 'type-e',
      bedrooms: 2,
      area: '1495 Sq.Ft',
      title: 'Two Luxury Bedrooms with Attached Washrooms',
      features: [
        'Spacious Lounge and Dining Area',
        'American Style Kitchen',
        'Separate Balconies from Every Room',
        'Spaciously Built Garden Area',
        'Reserved Basement Parking',
        'Dam or Mountain View through Wide Garden'
      ],
      image: 'https://images.unsplash.com/photo-1560185127-6ed189bf02f4?w=800&q=80'
    }
  ];

  const AMENITIES = [
    'Cash and Carry',
    'Hospital',
    'Gym',
    'Day Care Center',
    'Mini Gaming Zone',
    'Mosque',
    'Coffee Shop and Top Notch Restaurant'
  ];

  return (
    <div className="min-h-screen bg-gray-50">
         <Helmet>
                  <title>Sukoon Vista | Luxury Apartments in Islamabad</title>
                  <meta name="description" content="Experience luxury living at Sukoon Vista. Premium apartments with dam and mountain views, modern amenities, and unmatched comfort." />
                  <meta name="keywords" content="Sukoon Vista, Islamabad, Luxury Apartments, Real Estate Islamabad, Property Investment, Marketing & Developers, Apartment for Sale" />
                  
                  {/* Open Graph / Facebook */}
                  <meta property="og:type" content="website" />
                  <meta property="og:url" content="https://b7tower.com/" />
                  <meta property="og:title" content="Sukoon Vista | Luxury Apartments in Islamabad" />
                  <meta property="og:description" content="Sukoon Vista offers premium apartments with dam and mountain views, modern amenities, and unmatched comfort." />
                  <meta property="og:image" content={SukoonVistaCover} />
        
                  {/* Twitter */}
                  <meta property="twitter:card" content="summary_large_image" />
                  <meta property="twitter:url" content="https://b7tower.com/" />
                  <meta property="twitter:title" content="Sukoon Vista | Luxury Apartments in Islamabad" />
                  <meta property="twitter:description" content="Sukoon Vista offers premium apartments with dam and mountain views, modern amenities, and unmatched comfort." />
                  <meta property="twitter:image" content={SukoonVistaCover} />
                  
                  {/* JSON-LD Structured Data */}
                  <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                  </script>
                </Helmet>
      {/* Hero Section */}
      <section 
        className="relative min-h-[90vh] flex items-center justify-center px-4 bg-cover bg-center"
        style={{ 
          backgroundImage: `url(${SukoonVistaCover})`
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <div className="inline-block px-6 py-2 mb-4 border border-white/30 rounded-full text-sm tracking-widest uppercase bg-black/20 backdrop-blur-sm">
            <i className="fas fa-home mr-2"></i> Sukoon · Hussain Builders
          </div>
          <h1 className="text-5xl md:text-7xl font-bold leading-tight">
            Your <span className="text-yellow-500">Dream Home</span> <br /> Awaits
          </h1>
          <p className="text-lg md:text-2xl mt-4 max-w-2xl mx-auto text-white/90">
            Luxury living with dam and mountain views, premium amenities, and unmatched comfort.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`https://wa.me/${WHATSAPP}`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg flex items-center justify-center gap-3 transition-all hover:scale-105"
            >
              <i className="fab fa-whatsapp text-2xl"></i> Book Now · WhatsApp
            </a>
            <button
              onClick={() => document.getElementById('units')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white/20 backdrop-blur-sm border border-white/40 px-8 py-4 rounded-full text-lg font-medium hover:bg-white/30 transition-all flex items-center gap-2"
            >
              <i className="fas fa-arrow-down"></i> View Floor Plans
            </button>
          </div>
          <div className="mt-6 text-sm opacity-75 flex flex-wrap justify-center gap-4">
            <span><i className="fas fa-check-circle text-green-400 mr-1"></i> Payment plan updates</span>
            <span><i className="fas fa-check-circle text-green-400 mr-1"></i> 100% trusted</span>
          </div>
        </div>
      </section>

      {/* Units Section */}
      <section id="units" className="py-16 px-4 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 inline-block border-b-4 border-yellow-600 pb-2">
            <i className="fas fa-building mr-3 text-yellow-600"></i> Floor Plans and Units
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Choose from our spacious luxury apartments, each designed with elegance and breathtaking views.
          </p>
        </div>

        {/* Unit Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {UNITS.map((unit) => (
            <button
              key={unit.id}
              onClick={() => setActiveUnit(unit.id)}
              className={`px-6 py-2 rounded-full font-medium transition-all border ${
                activeUnit === unit.id
                  ? 'bg-yellow-600 text-white border-yellow-600 shadow-lg'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
              }`}
            >
              {unit.bedrooms} BR · {unit.area}
            </button>
          ))}
        </div>

        {/* Active Unit Card */}
        {UNITS.map((unit) => {
          if (unit.id !== activeUnit) return null;
          return (
            <div 
              key={unit.id} 
              className="bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all md:flex"
            >
              <div className="md:w-1/2 h-72 md:h-auto">
                <img 
                  src={unit.image} 
                  alt={unit.title} 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 md:p-10 md:w-1/2">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="bg-yellow-100 text-yellow-800 px-4 py-1 rounded-full text-sm font-bold">
                    {unit.area}
                  </span>
                  <span className="bg-gray-200 px-4 py-1 rounded-full text-sm font-medium">
                    <i className="fas fa-bed mr-1"></i> {unit.bedrooms} Bedrooms
                  </span>
                </div>
                <h3 className="text-2xl font-bold mt-3">{unit.title}</h3>
                <ul className="mt-4 space-y-2 text-gray-700">
                  {unit.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <i className="fas fa-check-circle text-yellow-600 mt-1"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-6 pt-4 border-t border-gray-200 flex flex-wrap gap-3">
                  <a
                    href={`https://wa.me/${WHATSAPP}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-full font-medium flex items-center gap-2 shadow transition-all"
                  >
                    <i className="fab fa-whatsapp"></i> Inquire Now
                  </a>
                  <button className="border border-gray-400 px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-all flex items-center gap-2">
                    <i className="fas fa-file-pdf"></i> Payment Plan
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        <div className="mt-12 text-center text-sm text-gray-500 italic border-t border-gray-200 pt-8">
          <i className="fas fa-asterisk text-yellow-600 mr-1"></i> All units include reserved basement parking and scenic views.
        </div>
      </section>

      {/* Amenities Section */}
      <section className="py-16 px-4 bg-white border-t border-gray-200">
        <div className="max-w-6xl mx-auto">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-4">
            <i className="fas fa-concierge-bell text-yellow-600 mr-3"></i> Amenities
          </h3>
          <p className="text-center text-gray-600 mb-10">Everything you need, all right here.</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {AMENITIES.map((item, idx) => (
              <div 
                key={idx} 
                className="bg-gray-50 hover:bg-yellow-50 p-5 rounded-2xl text-center shadow-sm transition-all border border-gray-100 flex flex-col items-center"
              >
                <i className="fas fa-check-circle text-yellow-600 text-2xl mb-2"></i>
                <span className="font-medium text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-yellow-600/20 rounded-full flex items-center justify-center text-2xl">
              <i className="fas fa-home text-yellow-500"></i>
            </div>
            <div>
              <p className="font-bold text-lg">Hussain Builders</p>
              <p className="text-sm text-gray-400">Hussain Marketing · A Name of Trust</p>
            </div>
          </div>
          <div className="text-sm text-gray-400 flex flex-wrap gap-4">
            <span><i className="fas fa-phone-alt mr-1"></i> {WHATSAPP}</span>
            <span><i className="fas fa-map-pin mr-1"></i> Sukoon · Dam View</span>
            <a 
              href={`https://wa.me/${WHATSAPP}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-green-400 hover:text-green-300 transition"
            >
              <i className="fab fa-whatsapp mr-1"></i> WhatsApp
            </a>
          </div>
        </div>
        <div className="mt-6 text-center text-xs text-gray-600 border-t border-gray-800 pt-4">
          © 2026 Sukoon · All rights reserved. Presented by Hussain Builders.
        </div>
      </footer>
    </div>
  );
};

export default SukoonVista;